import { Alert, ListItem, Link, List, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as InnerLink } from "react-router-dom";

export default function PaymentFailure() {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} padding={2}>
      <Typography variant="h5">
        {t("purchaseParkingPermit.cancelPage.title")}
      </Typography>
      <Alert severity="error" sx={{ borderRadius: "15px" }}>
        <Stack spacing={2}>
          <Stack>
            <Typography variant="h6">
              {t("purchaseParkingPermit.cancelPage.description")}
            </Typography>
            <Typography>
              {t("purchaseParkingPermit.cancelPage.lede")}
            </Typography>
          </Stack>
          <Stack spacing={0}>
            <Typography>
              {t("purchaseParkingPermit.cancelPage.reasons.preamble")}
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 4 }} disablePadding={true}>
              {t("purchaseParkingPermit.cancelPage.reasons.causes", {
                returnObjects: true,
              }).map((item, idx) => {
                return (
                  <ListItem
                    sx={{ display: "list-item" }}
                    disablePadding={true}
                    key={idx}
                  >
                    {item}
                  </ListItem>
                );
              })}
            </List>
          </Stack>
          <Typography>
            {t("purchaseParkingPermit.cancelPage.reasons.postamble")}
          </Typography>
        </Stack>
      </Alert>
      <Link component={InnerLink} to="/purchase">
        ‹ {t("purchaseParkingPermit.cancelPage.returnToShop")}
      </Link>
    </Stack>
  );
}
